export const config = {
    apiUrl: process.env.REACT_APP_API_URL || '##API_URL##',
    wsUrl: process.env.REACT_APP_WS_URL || '##WS_URL##',
    defaultHourlyRate: process.env.REACT_APP_DEFAULT_HOURLY_RATE || '##DEFAULT_HOURLY_RATE##',
    appName: process.env.REACT_APP_APP_NAME || '##APP_NAME##',
    currency: process.env.REACT_APP_CURRENCY || '##CURRENCY##',
    timezone: process.env.REACT_APP_TIMEZONE || '##TIMEZONE##',
};